/* QUELL — 360 experience: the floating gallery pill opens a full-page modal with the
   momento360 tour for the currently selected Furniture Option, plus a thumbnail strip to
   switch between this product's furniture tours. Each thumb's data-p360-key is the
   handleized metaobject display_name, matched against the active Furniture pill's option
   value. The iframe loads on demand and is cleared on close. Mirrors OMNI. */
(function () {
  "use strict";
  if (window.__p360Init) return;
  window.__p360Init = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function handleize(s) {
    return s
      ? String(s)
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "")
      : "";
  }

  ready(function () {
    var modal = document.querySelector("[data-p360]");
    if (!modal) return;
    var frame = modal.querySelector("[data-p360-frame]");
    var thumbs = [].slice.call(modal.querySelectorAll("[data-p360-thumb]"));
    if (!frame || !thumbs.length) return;

    // The .segs control is the Furniture option (product-main renders segs only for the
    // non-colour option), so read the active seg directly — role-based, not by position.
    var currentFurnitureKey = function () {
      var on = document.querySelector(".segs .seg.on");
      if (!on) return "";
      return handleize(on.getAttribute("data-value") || on.textContent);
    };

    var activate = function (thumb) {
      thumbs.forEach(function (t) {
        var on = t === thumb;
        t.classList.toggle("on", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      var src = thumb.getAttribute("data-p360-src");
      if (src && frame.getAttribute("src") !== src) frame.src = src;
    };

    var open = function () {
      var key = currentFurnitureKey();
      var target = null;
      if (key) {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute("data-p360-key") === key) {
            target = thumbs[i];
            break;
          }
        }
      }
      activate(target || thumbs[0]);
      modal.removeAttribute("hidden");
      document.body.style.overflow = "hidden";
    };

    var close = function () {
      modal.setAttribute("hidden", "");
      document.body.style.overflow = "";
      frame.src = ""; // drop the tour connection while closed
    };

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-p360-open]")) {
        open();
        return;
      }
      var th = e.target.closest("[data-p360-thumb]");
      if (th && modal.contains(th)) {
        activate(th);
        return;
      }
      if (e.target.closest("[data-p360-close]")) {
        close();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hasAttribute("hidden")) close();
    });
  });
})();
